import { h } from "preact";

import classname from "../../../foundation/utils/classname";
import { RequiredOnly } from "../../../foundation/utils/UtilityTypes";
import { ButtonVariant } from "../Button";
import Dialog, { DialogProps } from "../Dialog";

import styles from "./Alert.module.css";

type Props = RequiredOnly<Omit<DialogProps, "width" | "height">, "title" | "description">;

function Alert({
    class: cssClass,
    tertiaryButtonProps: consumerTertiaryButtonProps,
    ...props
}: Props) {
    const tertiaryButtonProps = consumerTertiaryButtonProps ? {
        variant: "secondary" as ButtonVariant,
        ...consumerTertiaryButtonProps
    } : undefined;

    return (
        <Dialog
            {...props}
            class={classname(styles.alert, cssClass)}
            tertiaryButtonProps={tertiaryButtonProps}/>
    );
}

export default Alert;
export {
    Props as AlertProps
};
